import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  menuHeight: number | string;
  roleTitleFontSize: number;
  sidebarOpened: boolean;
  allElementsVisible: boolean;
}>()(
  (
    { tokens, transitions },
    { menuHeight, roleTitleFontSize, sidebarOpened, allElementsVisible },
  ) => ({
    sidebarRoleTitle: {
      display: 'flex',
      alignItems: 'center',
      height: 40,
      padding: tokens.spacing['8'],
      paddingTop: tokens.spacing['16'],
      fontSize: roleTitleFontSize,
      transition: `font-size ${transitions.easing.easeInOut} 0.5s`,
    },

    sidebarLinks: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: menuHeight,
      transition: `height ${transitions.easing.easeInOut} 0.5s`,
      overflow: 'hidden',
      willChange: 'height',
    },

    showAllButton: {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacing['8'],
      borderRadius: tokens.radius.s,
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: tokens.colors.bg.greyscale.secondary,
      },
    },

    expandMoreIcon: {
      transform: `rotate(${allElementsVisible ? 180 : 0}deg)`,
    },

    showAllButtonText: {
      opacity: sidebarOpened ? 1 : 0,
      transition: `opacity ${transitions.easing.easeInOut} 0.5s`,
    },
  }),
);
